export default __webpack_public_path__ + "static/aspen-USA-daff9fd10198c739b2ea562fc4ffee6c.jpg";